import { featureFlipFlagClient } from '@acorn/flip-react-client-sdk';
import {userName as getUserName} from '../authorization/authorization';
import { FeatureFlags } from './featureflags';
import { UPDATE_FEATURE_FLAG } from '../../components/Reducers/types';

export const isFeatureFlagEnable = async (flag, inculdeUserName = false) => {
  const userName = getUserName();
  const params =
    userName && inculdeUserName
      ? {
          custom: {
            userName: userName.toLowerCase()
          }
        }
      : {};
  const data = await featureFlipFlagClient(process.env.ENV, 'bf.ui', params, {
    baseUrl: 'https://flip-api.collegeboard.org'
  })(flag, false);
  return data.on;
};

//helper fn
const updateObj = (flag, status, context) => {
    context[flag] = status;
    return context;
}
//This fetches latest FF status and updates global state (to reduce redundancy)
export const updateFeatureFlag = async (flagName, dispatch, context) => {
    try{
        const status = await isFeatureFlagEnable(FeatureFlags[flagName], true);
        dispatch({type: UPDATE_FEATURE_FLAG, payload: updateObj(flagName, status, context)});
    }catch(e){
        console.error(`Feature Flag Error:`, e);
    };
};